/**
*	@constructor Script used for an image charts page
*/
var ImageCharts = function () {

};

(function ($) {

	/**
	*	@description Method used to initialize ImageCharts
	*/
	ImageCharts.prototype.init = function () {
		// Initialize events
		this.initEvents();

		// Initialize authorization token
		this.initAuthorizationToken();

		// Initialize line chart
		this.initLineChart();

		// Initialize spark chart
		this.initSparkChart();

		// Initialize swatches
		this.initSwatches();

		// Initialize clipboards
		new ChartworksClipboard('#line-chart-code-sample-copy-btn').init();
		new ChartworksClipboard('#spark-chart-code-sample-copy-btn').init();
	};

	/**
	*	@description Method used to initialize events
	*/
	ImageCharts.prototype.initEvents = function () {
		// Click event for line chart refresh button
		$('#line-chart-refresh-chart-btn').on('click', $.proxy(this.initLineChart, this));

		// Click event for spark chart refresh button
		$('#spark-chart-refresh-chart-btn').on('click', $.proxy(this.initSparkChart, this));
	};

	/**
	*	@description Method used to initialize an authorization token for chart requests
	*/
	ImageCharts.prototype.initAuthorizationToken = function () {
		//$.ajaxSetup({
		//	headers : {
		//		'Authorization': 'demo-token'
		//	}
		//});
	};

	/**
	*	@description Method used to get environment-specific image API path
	*/
	ImageCharts.prototype.getAPIPath = function () {
		return /chartworks\.io/i.test(document.domain) ? 'https://api.markitondemand.com/apiman-gateway/MOD/chartworks-image/1.0/' : 'https://api.markitqa.com/apiman-gateway/MOD/chartworks-image/1.0/'
	};

	/**
	*	@description Method used to initialize a line chart
	*/
	ImageCharts.prototype.initLineChart = function () {

		var $chartTarget = $('#line-chart-target');
		var chartRequestUrl = this.getAPIPath() + 'chart/price';
		var lineChartFontColorInputValue = $('#line-chart-font-color-input').val();
		var lineChartHeightInputValue = $('#line-chart-height-input').val();
		var lineChartLineColorInputValue = $('#line-chart-line-color-input').val();
		var lineChartWidthInputValue = $('#line-chart-width-input').val();
		var lineChartVolumeColorInputValue = $('#line-chart-volume-color-input').val();
		var lineChartVolumeRadioValue = $('.line-chart-volume-radio:checked').val();

		// Set chart inputs
		var chartInputs = {
			'symbol' : 'AAPL',
			'exchange' : 'NSQ',
			'cultureCode' : 'en-US',
			'fontColor': lineChartFontColorInputValue || '#333333',
			'fontSize': 12,
			'height': lineChartHeightInputValue || 286,
			'heightLower' : 50,
			'numDays' : 365,
			'priceLineColor': lineChartLineColorInputValue || '#FFA500',
			'priceLineWeight' : 2,
			'showVolume': lineChartVolumeRadioValue == 1 ? true : false,
			'volumeColor': lineChartVolumeColorInputValue || '#ffa500',
			'width': lineChartWidthInputValue || 616,
			'xGridLineColor' : '#999999',
			'xGridLineWeight' : 1,
			'yGridLineColor' : '#999999',
			'yGridLineWeight' : 1
		};

		// Request chart
		this.requestChart($chartTarget, chartRequestUrl, chartInputs);
	};
	
	/**
	*	@description Method used to initialize a spark chart
	*/
	ImageCharts.prototype.initSparkChart = function () {

		var $chartTarget = $('#spark-chart-target');
		var chartRequestUrl = this.getAPIPath() + 'chart/sparkline';
		var sparkChartBackgroundColorInputValue = $('#spark-chart-background-color-input').val();
		var sparkChartHeightInputValue = $('#spark-chart-height-input').val();
		var sparkChartLineColorInputValue = $('#spark-chart-line-color-input').val();
		var sparkChartWidthInputValue = $('#spark-chart-width-input').val();

		// Set chart inputs
		var chartInputs = {
			'symbol' : 'AAPL',
			'exchange' : 'NSQ',
			'numDays' : 365,
			'backgroundColor' : sparkChartBackgroundColorInputValue || '#FFFFFF',
			'height' : sparkChartHeightInputValue || 128,
			'priceLineColor' : sparkChartLineColorInputValue || '#00C853',
			'priceLineWeight' : 2,
			'priceNegativeColor' : '#C0202D',
			'pricePositiveColor' : '#1D8343',
			'showChange' : false,
			'width' : sparkChartWidthInputValue || 228
		};

		// Request chart
		this.requestChart($chartTarget, chartRequestUrl, chartInputs);
	};

	/**
	*	@description Set swatch background colors
	*/
	ImageCharts.prototype.initSwatches = function () {

		var swatchColors = [
			"#2496f1",
			"#f98254",
			"#009487",
			"#9d9d9d",
			"#e220a8",
			"#192f41",
			"#fd0000",
			"#dd4bf9",
			"#76c147",
			"#ad81c7",
			"#04bbd3",
			"#fcd32e",
			"#4b7bbb",
			"#00c02f"
		];

		function componentToHex(c) {
			var hex = c.toString(16);
			return hex.length == 1 ? "0" + hex : hex;
		}

		function rgbToHex(r, g, b) {
			return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
		}

		// create expanded wrapper
		var $expanded = $("<div class=\"colorswatch-expanded\">").appendTo("body")
			.on("mouseenter", function(){

				$(this).data("isHover", true);
			})
			.on("mouseleave", function(){

				$(this).data("isHover", false);
				$(this).hide();
			})
			.on("click", "div", function(){

				var color = $(this).data("hex-color").toUpperCase();

				var elFor = $("#" + $(this).parent().data("for"));
				elFor.val(color);
				elFor.siblings(".colorswatch-select").eq(0).css("background-color", color);

				$(this).parent().data("isHover", false);
				$(this).parent().hide();
			});

		// populate wrapper
		swatchColors.map(function(row){

			$("<div/>")
				.css("background-color", row)
				.data("hex-color", row)
				.appendTo($expanded);
		});

		$(".colorswatch-select").on("mouseenter", function(){

			var $el = $(".colorswatch-expanded"),
				offset = $(this).offset();

			$el
				.data("for", $(this).attr("for"))
				.css("left", offset.left - 88)
				.css("top", offset.top - $el.height() - 2)
				.show();
		});

		$(".colorswatch-select").on("mouseleave", function(){

			var $el = $(".colorswatch-expanded");

			window.setTimeout(function(){

				if (!$(".colorswatch-expanded").data("isHover")){
					$el.hide();
				}

			}, 100);
		});

		// colorize swatches
		$(".colorswatch-select").each(function(){

			var $el = $(this),
				elFor = $("#" + $(this).attr("for")),
				color = elFor.val();

			$(this).css("background-color", color);

			elFor.on("change", function(){

				var color = $(this).val();

				if (/^#[0-9a-f]{6}$/i.test(color)){
					$el.css("background-color", color);
				}
			})
		});
	};

	/**
	*	@description Method used to initialize a spark chart
	*	@param $chartTarget: A jquery selector for the chart container
	*	@param chartRequestUrl: A url used to request the chart via ajax
	*	@param chartInputs: An object representing the chart inputs
	*/
	ImageCharts.prototype.requestChart = function ($chartTarget, chartRequestUrl, chartInputs) {
		var encodedInputs;

		// Check for valid inputs
		if ($chartTarget && $chartTarget.length > 0 && chartRequestUrl && chartRequestUrl.length > 0 && chartInputs) {
			// Stringify and encode inputs
			encodedInputs = encodeURIComponent(JSON.stringify(chartInputs, null));

			var url = chartRequestUrl + '?inputs=' + encodedInputs + "&access_token=demo-token";
			var $img = $("<img />").attr("src", url);
			$chartTarget.empty().append($img);

		}
	};

})(jQuery);
